// ===== Commissions › Calculator — the math and the exemption vocabulary =====
//
// Pure, module-scope, no React: a gate RUNS this (verify-commission-calculator.js)
// instead of reading the card's JSX as prose. The formulas are the canonical
// commission-tax model (CLAUDE.md "Commission Tax Canonical Model"), unchanged:
//
//   gross       = unitValue × rate            (rate as a decimal: 4.5% → 0.045)
//   netOfVat    = gross / 1.14
//   vat         = gross − netOfVat
//   withholding = netOfVat × 0.05             (0 when exempt)
//   netDue      = gross − withholding
//
// THE EXEMPTION FLAG, 2026-10-31. The calculator's checkbox used to be
// "Withholding 5%" — checked (default) = apply it. Claims reads the other way:
// a cycle carries `withholdingExempt`, and its badge says "No 5% W/H". Two
// surfaces describing the same 5% with opposite checkbox meanings is how a
// ticked box gets read backwards, so the calculator now speaks Claims' language:
// unchecked (default) = withholding applied; checked = exempt, Net Due = Gross.
//
// Intermediates are NOT rounded (same as before); the display formatter rounds.
// Fixture, 13,078,000 @ 4.5%: gross 588,510.00 · VAT 72,273.16 · net of VAT
// 516,236.84 · withholding 25,811.84 · Net Due 562,698.16; exempt → 0 / 588,510.00.

export var CALC_EXEMPT_LABEL = "No 5% W/H";   // the Claims badge wording, verbatim (owner 2026-10-31)
export var CALC_EXEMPT_TITLE = "Under new tax regulation — no 5% withholding; the full gross is due";
export var CALC_EXEMPT_DEFAULT = false;   // unchecked = withholding applied (Claims' default too)
export var CALC_RATE_PLACEHOLDER = "3";
export var CALC_CARD_MAX_WIDTH = 600;   // the original card width; the card is centred with margin auto

// unitValue: Number (already parsed; NaN/undefined → 0)
// ratePct:   Number or numeric string in PERCENT (4.5 → 4.5%)
// withholdingExempt: Boolean (true = no 5% withholding)
export function calcCommissionBreakdown(unitValue, ratePct, withholdingExempt) {
  var unit = Number(unitValue);
  if (!isFinite(unit) || unit < 0) unit = 0;
  var rateRaw = parseFloat(ratePct);
  var rateDec = isFinite(rateRaw) ? rateRaw / 100 : 0;
  var gross = unit > 0 && rateDec > 0 ? unit * rateDec : 0;
  var netOfVat = gross > 0 ? gross / 1.14 : 0;
  var vat = gross - netOfVat;
  var withholding = withholdingExempt ? 0 : netOfVat * 0.05;
  var netDue = gross > 0 ? gross - withholding : 0;
  return { gross: gross, netOfVat: netOfVat, vat: vat, withholding: withholding, netDue: netDue, exempt: !!withholdingExempt };
}
